import { render, staticRenderFns } from "./AddPromoteSet.vue?vue&type=template&id=1b704025&scoped=true"
import script from "./AddPromoteSet.vue?vue&type=script&lang=js"
export * from "./AddPromoteSet.vue?vue&type=script&lang=js"
import style0 from "./AddPromoteSet.vue?vue&type=style&index=0&id=1b704025&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b704025",
  null
  
)

export default component.exports